import { isPlatformServer } from '@angular/common';
import { Directive, ElementRef, Input, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { LocalStorageService} from 'ngx-webstorage';

@Directive({
    selector: '[cache]',
    standalone:false
})
export class ImageCacheDirective implements AfterViewInit {
    @Input() cache: string;

    constructor(
        public el: ElementRef,
        private localStorage: LocalStorageService,
        @Inject(PLATFORM_ID) private platformId: string
    ) { }

    ngAfterViewInit() {
        if (isPlatformServer(this.platformId)) return;
        if(window.location.hostname === 'localhost') return;
        this.el.nativeElement.crossOrigin = null; // CORS enabling
        let cache = !!this.cache && this.getWithExpiry(this.cache) || null;

        if (!!cache) {
            this.el.nativeElement.src = cache;
        }
        else {
            this.cacheImage();
        }
    }

    setWithExpiry(key, value, ttl) {
        const now = new Date()

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        this.localStorage.store(key, JSON.stringify(item))
    }

    getWithExpiry(key) {
        const itemStr = this.localStorage.retrieve(key);
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr || '{}');
        const now = new Date()
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            this.localStorage.clear(key)
            return null
        }
        return item.value
    }

    cacheImage(proxy: boolean = false) {
        let xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = () => {
            let reader = new FileReader();
            reader.onloadend = () => {

                let now = new Date();
                now.setTime(now.getTime() +  2 * 24 * 3600 * 1000);

                this.setWithExpiry(this.cache, reader.result, 2 * 24 * 3600 * 1000)
                this.el.nativeElement.src = reader.result;
            }
            reader.readAsDataURL(xhr.response);
        };

        xhr.onerror = (error) => {
            console.warn(error, 'trying with proxy...')
            if(!proxy) {
                this.cacheImage(true);
            }
            else {
                console.error('Giving up cache, setting src to url!');
                this.el.nativeElement.src = this.cache;
            }
        }

        let url = this.cache;
        if (proxy) {
            url = 'https://crossorigin.me/' + url;
        }

        xhr.open('GET', url);
        xhr.send();
    }
}
